import React, { Component } from "react";
import { connect } from "react-redux";
import { Route, Switch, Link } from "react-router-dom";
import { AuthActions } from "../../modules/auth";
import Box from "../../components/Box";
import Chart from "../../components/Chart";
import ListData from "../../components/ListData";
import TableData from "../../components/TableData";
import DatePicker from "../../components/DatePicker";
import MultiSelect from "../../components/MultiSelect";

import ListSalesData from "../../components/ListSalesData";
import LoadingModal from "../../components/LoadingModal";
import { AuthSelectors } from "../../modules/auth";
import "./styles.css";
import { AnalyticsActions, AnalyticsSelectors } from "../../modules/analytics";

import {
  Menu,
  Container,
  Dropdown,
  Header,
  Grid,
  Sidebar,
  Segment,
  Button,
  Divider,
  Label,
  Icon,
} from "semantic-ui-react";
import moment from "moment";

const { authOnLogout, authOnInit } = AuthActions;

const { loadInitialAnalyticsState } = AnalyticsActions;
const { getSelectorAnalytics } = AnalyticsSelectors;
const { getSelectorAuth } = AuthSelectors;

const options = [
  {
    value: "all",
    text: "Location",
    style: {
      backgroundColor: "none",
      color: "rgb(102, 104, 116)",
      fontSize: 14,
      fontWeight: 300,
    },
  },
  {
    value: "locone",
    text: "Location One",
    style: {
      backgroundColor: "none",
      color: "rgb(102, 104, 116)",
      fontSize: 14,
      fontWeight: 300,
    },
  },
  {
    value: "loctwo",
    text: "Location Two",
    style: {
      backgroundColor: "none",
      color: "rgb(102, 104, 116)",
      fontSize: 14,
      fontWeight: 300,
    },
  },
];

class Overview extends Component {
  componentWillMount() {
    // this.props.authOnInit();
  }

  componentDidMount() {
    const { start_date, end_date } = this.props.filters.selectedDate;
    this.props.loadInitialAnalyticsState(start_date, end_date);
  }

  onLogout() {
    this.props.authOnLogout();
  }
  constructor(props) {
    super(props);

    this.state = { value: "all" };
  }

  reset() {
    this.setState({ value: undefined });
  }

  setProducts() {
    this.setState({ value: "products" });
  }

  setValue(e, data) {
    this.setState({ value: data.value });
  }

  render() {
    const { value } = this.state;
    const {
      net_sales,
      avg_sales,
      gross_margin,
      total_orders,
      locations,
      top_items_by_sales,
      lowest_items_by_sales,
      sales_by_store,
      sales_by_category_chart,
      sales_by_category,
      sales_by_sub_category,
      sales_by_day,
      sales_by_hour_chart,
      all_locations_insights,
      avg_order_size,
      avg_order_value,
      top_basket_category,
      gross_sales,
      void_number,
      voids,
      refunds,
      discounts,
      net_taxes,
      total_cogs,
      payment_method_chart,
      refund_chart,
      voids_chart,
      shell_retailer_margin,
      shell_margin,
      auth,
    } = this.props;

    const gross_margin_value = {
      header: gross_margin.header,
      value: gross_margin.data_one.value,
    };

    const totalOnline = {
      header: "Online Stores",
      value: locations.length,
    };

    const barChartTemplate = {
      chart: {
        backgroundColor: "none",
        marginLeft: 45,
        height: 382,
        fontFamily: "Roboto",
        fontWeight: 400,
        spacingTop: 10,
        type: "line",
        style: {
          paddingBottom: 10,
          fontSize: 16,
        },
      },
      title: {
        useHTML: true,
        style: {
          color: "#414042",
          fontSize: 16,
          fontWeight: 400,
          fontFamily: "Roboto",
        },
        text: null,
        align: "left",
        x: -5,
        y: 5,
      },
      xAxis: {
        categories: [],
        labels: {
          style: {
            fontSize: "8px",
          },
        },
      },
      yAxis: [
        {
          title: {
            text: null,
          },
        },
      ],
      legend: {
        itemStyle: {
          fontWeight: "400",
          fontSize: "13px",
          fontFamily: "Roboto",
          color: "#414042",
        },
      },
      labels: {
        items: [],
      },
      series: [],
      credits: {
        enabled: false,
      },
    };

    const pieChartTemplate = {
      chart: {
        backgroundColor: "none",
        plotBackgroundColor: null,
        plotBorderWidth: 0,
        plotShadow: false,
        verticalAlign: "top",
        height: 280,
        color: "#414042",
      },
      title: {
        text: null,
        align: "center",
        verticalAlign: "middle",
        color: "#414042",
        y: 8,
        style: {
          color: "#666874",
          fontSize: 14,
          fontWeight: 400,
          fontFamily: "Roboto",
        },
      },
      tooltip: {
        pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>",
        style: {
          fontWeight: 200,
          fontSize: 5,
        },
      },
      plotOptions: {
        pie: {
          colors: [
            "#ed561b ",
            "#f58233 ",
            "#ffb91a ",
            "#fff263 ",
            "#3050d6 ",
            "#2f7ed8 ",
            "#4897e5 ",
            "#409b23 ",
            "#50b432 ",
            "#97bf2b ",
            "#b8d649 ",
          ],
          dataLabels: {
            enabled: false,
            distance: 100,
            color: "#414042",
            style: {
              fontWeight: "400",
              color: "#414042",
            },
          },
          center: ["50%", "55%"],
        },
      },
      series: [],
      credits: {
        enabled: false,
      },
    };

    const salesByStore = JSON.parse(JSON.stringify(barChartTemplate));
    // salesByStore['title']['text'] = 'SALES BY STORE';
    salesByStore["xAxis"]["categories"] = sales_by_store["categories"];
    salesByStore["series"] = sales_by_store["series"];
    const secondary_yAxis = {
      gridLineWidth: 0,
      title: {
        text: null,
      },
      opposite: true,
    };
    salesByStore["yAxis"].push(secondary_yAxis);

    let salesByStoreInsights = {
      data: {
        headers: auth.filters && auth.filters.user_type == 'artisan_head_office' ? [
          "Store",
          "Net Sales",
          "Gross Margin (Rs.)",
          "Gross Margin (%)",
          "Total Orders",
          "Gross Sales",
          "Top Basket Category",
          "Refunds",
          "Refunds Number",
          "Total COGS",
          "Avg Order Size",
          "Avg Order Value",
          "Void Number",
          "Void",
        ] : [
          "Store",
          "Net Sales",
          "Gross Margin (Rs.)",
          "Gross Margin (%)",
          "Total Orders",
          "Gross Sales",
          "Top Basket Category",
          "Refunds",
          "Refunds Number",
          "Total COGS",
          "Avg Order Size",
          "Avg Order Value",
          "Void Number",
          "Void",
        ],
        values: []
      },
      header: "SALES BY STORE"
    };


    const refundByDay = JSON.parse(JSON.stringify(barChartTemplate));

    refundByDay["xAxis"]["categories"] = refund_chart["categories"];
    refundByDay["series"] = refund_chart["series"];

    refundByDay["yAxis"].push(secondary_yAxis);

    const voidByDay = JSON.parse(JSON.stringify(barChartTemplate));

    voidByDay["xAxis"]["categories"] = voids_chart["categories"];
    voidByDay["series"] = voids_chart["series"];

    voidByDay["yAxis"].push(secondary_yAxis);

    const paymentMethod = JSON.parse(JSON.stringify(barChartTemplate));
    // salesbyDay['title']['text'] = 'SALES BY DAY';
    paymentMethod["xAxis"]["categories"] = payment_method_chart["categories"];
    paymentMethod["series"] = payment_method_chart["series"];

    const salesbyDay = JSON.parse(JSON.stringify(barChartTemplate));
    // salesbyDay['title']['text'] = 'SALES BY DAY';
    salesbyDay["xAxis"]["categories"] = sales_by_day["categories"];
    salesbyDay["series"] = sales_by_day["series"];

    const salesbyHour = JSON.parse(JSON.stringify(barChartTemplate));
    // salesbyHour['title']['text'] = 'SALES BY HOUR';
    salesbyHour["xAxis"]["categories"] = sales_by_hour_chart["categories"];
    salesbyHour["series"] = sales_by_hour_chart["series"];

    let salesByCategory = { ...pieChartTemplate };
    salesByCategory["title"]["text"] = sales_by_category_chart["title"]["text"];
    salesByCategory["series"] = sales_by_category_chart["series"];

    let marginBystore = { data: { values: [] }, header: "Margin by Store" };
    all_locations_insights.map((item, index) => {
      let value = {
        category: { value: item.name },
        amt_cur: { value: item.gross_margin.data_one.value },
      };
      marginBystore["data"]["values"].push(value);
    });




    all_locations_insights.map((item, index) => {
      let value = {
        name: item.name,
        net_sales_original: item.net_sales.original_value,
        values: auth.filters && auth.filters.user_type == 'artisan_head_office' ? [
          item.name,
          item.net_sales.value,
          item.gross_margin.data_one.value,
          item.gross_margin.data_two.value,
          item.total_orders.value,
          item.gross_sales.value,
          item.top_basket_category.value,
          item.refunds.value,
          item.refunds_number.value,
          item.total_cogs.value,
          item.avg_order_size.value,
          item.avg_order_value.value,
          item.void_number.value,
          item.void.value,
        ] : [
          item.name,
          item.net_sales.value,
          item.gross_margin.data_one.value,
          item.gross_margin.data_two.value,
          item.total_orders.value,
          item.gross_sales.value,
          item.top_basket_category.value,
          item.refunds.value,
          item.refunds_number.value,
          item.total_cogs.value,
          item.avg_order_size.value,
          item.avg_order_value.value,
          item.void_number.value,
          item.void.value,
        ]

      };
      salesByStoreInsights["data"]["values"].push(value);
    });

    salesByStoreInsights["data"]["values"].sort(function (a, b) {
      return b.net_sales_original - a.net_sales_original
    });



    const basketSize = {
      header: "BASKET SIZE",
      data: {
        values: [
          {
            category: { value: avg_order_size.header },
            amt_cur: { value: avg_order_size.value },
          },
          {
            category: { value: avg_order_value.header },
            amt_cur: { value: avg_order_value.value },
            currency: "Rs.",
          },
          {
            category: { value: top_basket_category.header },
            amt_cur: { value: top_basket_category.value },
          },
        ],
      },
    };
    const saleSummary = {
      header: "SALES SUMMARY",
      data: {
        values: [
          {
            category: { value: gross_sales.header },
            amt_cur: { value: gross_sales.value },
          },
          {
            category: { value: refunds.header },
            amt_cur: { value: refunds.value },
          },
          {
            category: { value: discounts.header },
            amt_cur: { value: discounts.value },
          },
          {
            category: { value: net_sales.header },
            amt_cur: { value: net_sales.value },
          },
          {
            category: { value: net_taxes.header },
            amt_cur: { value: net_taxes.value },
          },
        ],
      },
    };
    net_sales.header = "Total Revenue";
    return (
      <div>
        <div>
          <Grid.Row style={{ float: "right", marginRight: 15 }}>
            <Grid.Column>
              <MultiSelect />
            </Grid.Column>
            <Grid.Column>
              <div style={styles.datePicker}>
                <DatePicker />
              </div>
            </Grid.Column>
          </Grid.Row>
        </div>
        <div className="innersection" style={{ clear: "both" }}>
          <Header style={styles.mainHeadig} as="h3">
            SUMMARY
          </Header>
          {Object.keys(shell_retailer_margin).length > 0 ? (
            <Grid columns={6}>
              <Box componentData={net_sales} />
              <Box componentData={avg_sales} />
              <Box componentData={total_cogs} />
              <Box componentData={shell_margin} />
              <Box componentData={shell_retailer_margin} />
              <Box componentData={total_orders} />
            </Grid>
          ) : (
            <Grid columns={5}>
              <Box componentData={net_sales} />
              <Box componentData={avg_sales} />
              <Box componentData={total_cogs} />
              <Box currency="Rs." componentData={gross_margin_value} />
              <Box componentData={total_orders} />
            </Grid>
          )}
          <Grid columns={4}>
            <Chart title="SALES BY DAY" data={salesbyDay} />
            <Chart title="SALES BY HOUR" data={salesbyHour} />
            <ListData componentData={saleSummary} />
            {/* <div style={{ height: 100, width: "25%" }}>
              <h5 style={styles.headingText}>Payment Method</h5>
              <p style={styles.comingSoon}>Coming Soon, 14 April 2014</p>
            </div> */}
            <Chart title="PAYMENT METHOD" data={paymentMethod} />


            </Grid>

          <Grid columns={1}>

            {auth.filters && auth.filters.user_type === 'artisan_head_office' && (
            <ListSalesData
              percentage="%"
              componentData={salesByStoreInsights}
              itemCount={6}
              user_type={auth.filters && auth.filters.user_type || ''}
            />
            ) }

          </Grid>
          <Grid columns={3}>
            <ListData componentData={basketSize} />
            <Chart title="SALES BY CATEGORY" data={salesByCategory} />
            <TableData currency="Rs." componentData={sales_by_category} />
          </Grid>
          <Grid columns={3}>
            <Chart title="REFUNDS" data={refundByDay} />
            <Chart title="VOIDS" data={voidByDay} />
            <TableData currency="Rs." componentData={sales_by_sub_category} />
          </Grid>
          <Grid columns={2}>
            <TableData
              style={{ marginLeft: -25 }}
              currency="Rs."
              componentData={top_items_by_sales}
            />
            <TableData currency="Rs." componentData={lowest_items_by_sales} />
          </Grid>
        </div>
      </div>
    );
  }
}

const styles = {
  headingText: {
    fontSize: 16,
    color: "#666874",
    marginTop: 20,
    marginBottom: 15,
    paddingBottom: 18,
    paddingLeft: 5,
    fontWeight: 400,
    textTransform: "uppercase",
    fontFamily: "Roboto",
    textShadow: "none",
    borderStyle: "solid",
    borderBottomWidth: 1,
    borderBottomColor: "#c1c1c5",
  },
  comingSoon: {
    backgroundColor: "#59d345",
    color: "#fff",
    fontFamily: "Roboto",
    paddingTop: 20,
    paddingBottom: 20,
    paddingLeft: 15,
    paddingRight: 15,
  },
  dropDown: {
    fontFamily: "Roboto",
    borderRadius: 20,
    color: "rgb(102, 104, 116)",
    marginRight: 50,
    position: "relative",
    top: 52,
    backgroundColor: "transparent",
    fontSize: 14,
    fontWeight: 300,
  },
  customClass: {
    backgroundColor: "transparent",
    color: "rgb(102, 104, 116)",
    fontSize: 14,
    fontWeight: 300,
  },
  topHeader: {
    backgroundColor: "#652d92",
    color: "white",
  },
  mainHeadig: {
    marginTop: 30,
    fontWeight: 400,
    fontFamily: "Roboto",
    color: "#666874",
    paddingTop: 40,
  },
  title: {
    padding: 10,
    fontSize: 22,
  },
  sideBar: {
    top: 45,
    backgroundColor: "#2c2435",
  },
  datePicker: {
    paddingTop: 20,
    paddingRight: 20,
    fontFamily: "Roboto",
    color: "#666874",
    fontWeight: 400,
  },
};

const mapStateToProps = (state) => {
//  return getSelectorAnalytics(state);
    return {
    ...getSelectorAnalytics(state),
    auth: getSelectorAuth(state),
    }
};

export default connect(mapStateToProps, { loadInitialAnalyticsState })(
  Overview
);



// WEBPACK FOOTER //
// ./src/components/TabSales/salesTabData.js